import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.sort.js";
import React from 'react';
import { countriesI18n } from "../../../countries";
import { useTranslation } from 'react-i18next';
import { nsform } from "../../../../i18n/namespaces";
import { callingCodePriorities, phoneCountriesRaw } from "./phone-country.utils";
export const usePhoneCountries = (onlyCountries, excludeCountries) => {
  const {
    i18n
  } = useTranslation(nsform.common);
  const [search, setSearch] = React.useState('');
  const ccRawFilter = React.useCallback(raw => {
    if (onlyCountries && onlyCountries.length > 0) return onlyCountries.includes(raw.alpha2);else if (excludeCountries && excludeCountries.length > 0) return !excludeCountries.includes(raw.alpha2);else return true;
  }, [onlyCountries, excludeCountries]);
  const ccData = React.useMemo(() => {
    return phoneCountriesRaw.filter(ccRawFilter).map(({
      alpha2,
      code
    }) => {
      var _countriesI18n$getNam;
      return {
        alpha2,
        code,
        name: (_countriesI18n$getNam = countriesI18n.getName(alpha2, i18n.language)) !== null && _countriesI18n$getNam !== void 0 ? _countriesI18n$getNam : ''
      };
    }).filter(cc => cc.name).sort((cc1, cc2) => cc1.name < cc2.name ? -1 : 1);
    return [];
  }, [i18n.language, ccRawFilter]);
  const cc = React.useMemo(() => search ? ccData.filter(cc => cc.name.toLowerCase().includes(search.toLowerCase())) : ccData, [search, ccData]);
  const ccFromCallingCode = React.useCallback(code => {
    var _cc$find$alpha, _cc$find;
    const priorityCC = callingCodePriorities[code];
    if (priorityCC) {
      if (cc.find(cc => cc.alpha2 === priorityCC)) return priorityCC;
    }
    return (_cc$find$alpha = (_cc$find = cc.find(cc => cc.code === code)) === null || _cc$find === void 0 ? void 0 : _cc$find.alpha2) !== null && _cc$find$alpha !== void 0 ? _cc$find$alpha : null;
  }, [cc]);
  return {
    cc,
    ccFromCallingCode,
    search,
    onSearch: setSearch
  };
};